import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  error: "",
  pageLoading: false,
  runbookLoading: false,
  runbooks: [],
  runbooksPagination: {},
  runbookDetail: null,
  runbookDetailLoading: false,
  runbookActionDetail: null,
  runbookActionDetailLoading: false,
});

export default function runbooksReducer(state = initialState, action) {
  switch (action.type) {
    // List
    case ACTIONS.RUNBOOKS.PENDING:
      return state.set("pageLoading", true).set("error", "");
    case ACTIONS.RUNBOOKS.SUCCESS:
      return state
        .set("pageLoading", false)
        .set("error", "")
        .set("runbooks", action.data.data)
        .set("runbooksPagination", action.data.pagination);
    case ACTIONS.RUNBOOKS.ERROR:
      return state.set("pageLoading", false).set("error", action.error);

    // Detail
    case ACTIONS.RUNBOOK_DETAIL.PENDING:
      return state.set("runbookDetailLoading", true).set("error", "");
    case ACTIONS.RUNBOOK_DETAIL.SUCCESS:
      return state.set("runbookDetailLoading", false).set("runbookDetail", action.data);
    case ACTIONS.RUNBOOK_DETAIL.ERROR:
      return state.set("runbookDetailLoading", false).set("error", action.error);

    // Action Detail
    case ACTIONS.RUNBOOK_ACTION_DETAIL.PENDING:
      return state.set("runbookActionDetailLoading", true).set("runbookActionDetail", null).set("error", "");
    case ACTIONS.RUNBOOK_ACTION_DETAIL.SUCCESS:
      return state.set("runbookActionDetailLoading", false).set("runbookActionDetail", action.data);
    case ACTIONS.RUNBOOK_ACTION_DETAIL.ERROR:
      return state.set("runbookActionDetailLoading", false).set("error", action.error);

    // Create
    case ACTIONS.CREATE_RUNBOOK.PENDING:
      return state.set("runbookLoading", true).set("error", "");
    case ACTIONS.CREATE_RUNBOOK.SUCCESS:
      return state
        .set("runbookLoading", false)
        .set("runbooks", action.data.data)
        .set("runbooksPagination", action.data.pagination);
    case ACTIONS.CREATE_RUNBOOK.ERROR:
      return state.set("runbookLoading", false).set("error", action.error);

    // Update
    case ACTIONS.UPDATE_RUNBOOK.PENDING:
      return state.set("runbookLoading", true).set("error", "");
    case ACTIONS.UPDATE_RUNBOOK.SUCCESS:
      return state
        .set("runbookLoading", false)
        .set("runbooks", action.data.data)
        .set("runbooksPagination", action.data.pagination);
    case ACTIONS.UPDATE_RUNBOOK.ERROR:
      return state.set("runbookLoading", false).set("error", action.error);

    // Delete
    case ACTIONS.DELETE_RUNBOOK.PENDING:
      return state.set("runbookLoading", true).set("error", "");
    case ACTIONS.DELETE_RUNBOOK.SUCCESS:
      return state
        .set("runbookLoading", false)
        .set("runbooks", action.data.data)
        .set("runbooksPagination", action.data.pagination);
    case ACTIONS.DELETE_RUNBOOK.ERROR:
      return state.set("runbookLoading", false).set("error", action.error);

    // Start / Pause / Stop — refresh detail
    case ACTIONS.RUNBOOK_START.PENDING:
    case ACTIONS.RUNBOOK_STOP.PENDING:
      return state.set("runbookLoading", true).set("error", "");
    case ACTIONS.RUNBOOK_START.SUCCESS:
    case ACTIONS.RUNBOOK_STOP.SUCCESS:
      return state.set("runbookLoading", false).set("runbookDetail", action.data);
    case ACTIONS.RUNBOOK_START.ERROR:
    case ACTIONS.RUNBOOK_STOP.ERROR:
      return state.set("runbookLoading", false).set("error", action.error);

    // Duplicate runbook — refresh list
    case ACTIONS.DUPLICATE_RUNBOOK.PENDING:
      return state.set("runbookLoading", true).set("error", "");
    case ACTIONS.DUPLICATE_RUNBOOK.SUCCESS:
      return state
        .set("runbookLoading", false)
        .set("runbooks", action.data.data)
        .set("runbooksPagination", action.data.pagination);
    case ACTIONS.DUPLICATE_RUNBOOK.ERROR:
      return state.set("runbookLoading", false).set("error", action.error);

    // Action mutations — refresh detail
    case ACTIONS.CREATE_RUNBOOK_ACTION.PENDING:
    case ACTIONS.UPDATE_RUNBOOK_ACTION.PENDING:
    case ACTIONS.DELETE_RUNBOOK_ACTION.PENDING:
    case ACTIONS.COMPLETE_RUNBOOK_ACTION.PENDING:
    case ACTIONS.DUPLICATE_RUNBOOK_ACTION.PENDING:
    case ACTIONS.REORDER_RUNBOOK_ACTION.PENDING:
      return state.set("runbookLoading", true).set("error", "");
    case ACTIONS.CREATE_RUNBOOK_ACTION.SUCCESS:
    case ACTIONS.UPDATE_RUNBOOK_ACTION.SUCCESS:
    case ACTIONS.DELETE_RUNBOOK_ACTION.SUCCESS:
    case ACTIONS.COMPLETE_RUNBOOK_ACTION.SUCCESS:
    case ACTIONS.DUPLICATE_RUNBOOK_ACTION.SUCCESS:
    case ACTIONS.REORDER_RUNBOOK_ACTION.SUCCESS:
      return state.set("runbookLoading", false).set("runbookDetail", action.data);
    case ACTIONS.CREATE_RUNBOOK_ACTION.ERROR:
    case ACTIONS.UPDATE_RUNBOOK_ACTION.ERROR:
    case ACTIONS.DELETE_RUNBOOK_ACTION.ERROR:
    case ACTIONS.COMPLETE_RUNBOOK_ACTION.ERROR:
    case ACTIONS.DUPLICATE_RUNBOOK_ACTION.ERROR:
    case ACTIONS.REORDER_RUNBOOK_ACTION.ERROR:
      return state.set("runbookLoading", false).set("error", action.error);

    default:
      return state;
  }
}
